// @flow @jsx h
import { Component, h } from 'preact'
import { bem } from '@nrk/dh-utils'
import { ViewportIntersections, HtmlContent } from '@nrk/dh-feature-components'

/* styles */
import styles from './index.css'

/* types */
import type { TextType } from '../../domain'

type Props = {
  tekst: TextType[],
}

type State = {
  visible: boolean
}

export class VitenskapBlokk extends Component<Props, State> {
  handleEnter = () => {
    this.setState({ visible: true })
  }

  handleLeave = () => {
    this.setState({ visible: false })
  }

  render () {
    const { visible } = this.state
    return <ViewportIntersections
      className={bem(styles.vitenskapBlokk__wrapper, { visible })}
      threshold={[0.5]}
      onEnter={this.handleEnter}
      onLeave={this.handleLeave}>
      <div class={styles.vitenskapBlokk__innerWrapper}>

        <div className={styles.vitenskapBlokk__gardin} />
        <div className={styles.vitenskapBlokk__gardin} />
        <div className={styles.vitenskapBlokk__gardin} />

        <div class={styles.vitenskapBlokk}>
          <div class={styles.vitenskapBlokk__grid}>
            <div class={styles.vitenskapBlokk__text}>
              {
                this.props.tekst.map((contentElement, idx) => {
                  switch (contentElement.type) {
                    case 'text':
                      return <HtmlContent
                        key={idx}
                        type='p'
                        content={contentElement.value} />
                  }
                })

              }
            </div>
          </div>
        </div>
      </div>
    </ViewportIntersections>
  }
}
